import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import "swiper/css";

const UspSliderGrinwis = ({ usps }) => {
  return (
    <div className="w-full">
      <Swiper
        spaceBetween={24}
        slidesPerView="auto"
      >
        {usps?.map((usp) => {
          return (
            <SwiperSlide key={usp?.usp} className="!w-fit">
              <div className="flex items-center gap-[0.375rem]">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="w-auto text-xs text-primary"
                />
                <div className="text-xs text-placeholder">{usp?.usp}</div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default UspSliderGrinwis;
